import axios from 'axios';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    take : 10,
    page : 0,
    columns: [
        {
            key : "last_read_at",
            label : "read",
            display : true,
            type: "unread",
        },
        {
            key : "kooi.order_number",
            label : "order_number",
            setable: false,
            display : true
        },
        {
            key : "status",
            label : "Status",
            display : true
        },
        {
            key : "data.subject",
            label : "Subject",
            display : true
        },
        {
            key : "created_at",
            label: "created_at",
            display : true,
            type: "datetime",
        },
        {
            key : "data.type",
            label: "Type",
            display : true
        },
        {
            key : "last_read_at",
            label: "last_read_at",
            display : true,
            type: "datetime",
        },
        {
            key : "last_read_user.name",
            label: "last_read_by",
            display : true,
        },
    ],
    loaded : false,
    loadingMore: false,
    error : {
        load : false,
    },
    allLoaded : false,
    addNew : false,
    workingOn: [],
})

  // getters
  const getters = {
      isWorkingOn : (state) => (id) => {
          var index = state.workingOn.findIndex(id);
          if(index >= 0){
              return true;
          }else{
              return false;
          }
      }
  }

  // actions
  const actions = {
    async loadInbox({commit, state, rootState}){
        if(state.allLoaded == false){
            await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/dashboard/mails", {params: {page: state.page, take:state.take}}).then((response) => {
                commit("setMails", response.data);
                commit("loaded", false);
                commit("setError", {which: "load", status: false});
            }).catch(function(error){
                console.log(error.toJSON());
                commit("setError", {which: "load", status: true});
            })
        }
    },
    async setKooiId({commit, state, rootState}, data){
        commit("subLoading", data.data);
        await axios.put(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/emails/" + data.data.id, {kooi_id : data.kooi_id}).then((response) => {
            commit("updateMail", response.data);
            commit("subLoading", data.data);
        })

    },
    async deleteMail({commit, state, rootState}, data){
        commit("subLoading", data, true);
        await axios.delete(rootState.settings.url + "/api/v1/" + rootState.settings.internal.user_company + "/emails/" + data.id).then((response) => {
            commit("removeMail", data);
        })
    }
  }

  // mutations
  const mutations = {
    clean(state){
        state.allLoaded = false;
        state.list = [];
        state.loaded = false;
        state.workingOn = [];
      },
      subLoading(state, mail){
          var index = state.workingOn.findIndex(item => item = mail.id);
          if(index >= 0){
              state.workingOn.splice(index, 1);
          }else{
              state.workingOn.push(mail.id);
          }
      },
      newMail(state, mail){
        var index = state.list.findIndex(item => item.id == mail.id);
        if(index <= -1){
            state.list.unshift(mail);
        }else{
            state.list[index] = mail;
        }

      },
      updateMail(state, mail){
        var index = state.list.findIndex(item => item.id == mail.id);
        if(index >= 0){
            state.list[index] = mail;
        }
        },
      setMails(state, list){
          if(list == undefined || list.length <= 0){
            state.allLoaded = true;
          }
          state.list.push(...list);
      },
      removeMail(state, mail){
          var index = state.list.findIndex(item => item.id == mail.id);
          if(index >= 0){
              state.list.splice(index, 1);
          }
      },
      increasePage(state){
          state.loadingMore = true;
          state.page++;
      },
      loaded(state, status){
          state.loadingMore = status;
          state.loading = status;
      },
      setError(state, object){
          state.error[object.which] = object.status;
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
    }
  }
